import { useEffect } from 'react'
import {
  hasCustomerDisplaySecondaryScreen,
  prepareCustomerDisplayWindowConfig,
} from 'Views/CustomerDisplay/utils/customerDisplayWindow'

export const usePrepareCustomerDisplayWindowConfig = () => {
  useEffect(() => {
    const refreshCustomerDisplayWindowConfig = () => {
      if (!hasCustomerDisplaySecondaryScreen()) return

      prepareCustomerDisplayWindowConfig()
    }

    refreshCustomerDisplayWindowConfig()
    globalThis.addEventListener?.('focus', refreshCustomerDisplayWindowConfig)

    return () => {
      globalThis.removeEventListener?.(
        'focus',
        refreshCustomerDisplayWindowConfig
      )
    }
  }, [])
}
